export default __webpack_public_path__ + "static/media/bislig-project.c3363db0.mp4";